/**
 * Gets the base URL for the application.
 *
 * In Vercel preview deployments, we need to use the dynamic VERCEL_URL
 * instead of the static NEXT_PUBLIC_HOST environment variable. This ensures that
 * Stripe webhook URLs and redirect URLs work correctly for preview branches.
 * For production deployments, we use the official domain.
 *
 * @returns The base URL with protocol prefix (https://)
 */
export function getBaseUrl(): string {
  // For production deployments, use the official domain
  if (process.env.VERCEL_ENV === "production") {
    return "https://www.picstudio.ai";
  }

  // For Vercel preview deployments, use the automatically provided VERCEL_URL
  if (process.env.VERCEL_URL) {
    return `https://${process.env.VERCEL_URL}`;
  }

  // Fallback to the static NEXT_PUBLIC_HOST environment variable for local development
  return process.env.NEXT_PUBLIC_HOST || "http://localhost:3000";
}
